/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check-thin': {
    width: 13,
    height: 9.2,
    viewBox: '0 0 13 9.2',
    data: '<path pid="0" d="M11.6 0L5.1 6.5 1.4 2.8 0 4.1l5.1 5.1L13 1.4z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/check-thin.js